<template>
    <div class="card">
        <div class="card-header p-2">
            <div class="row">
                <div class="col-md-10 d-flex align-items-center">
                    <strong>{{ 'Partners > Marketing' }}</strong>
                </div>
                <div class="col-md-2">
                    <goback></goback>
                </div>
            </div>
        </div>
        <vue-tabs direction="horizontal" @tab-change="getTabData" active-text-color="black" v-model="curTab"
            class="m-2 tab-border">
            <v-tab :title="tabOneTitle">
                <div>
                    <div class="cat-compo">
                        <div style="margin: 0 auto;" class="mt-4 mb-4">
                            <!-- <h2>Marketing Page....</h2> -->
                            <UploadForm :getUrl="getUrl" :createUpdateUrl="createUpdateUrl" :deleteUrl="deleteUrl"
                                :getCategoryURL="getCategoryURL" :tabOneTitle="tabOneTitle"
                                :selectedCategoryObj="selectedCategoryObj" />
                        </div>
                    </div>
                </div>
            </v-tab>
            <v-tab title="view">
                <!-- THUMBNAIL -->
                <div class="d-flex justify-content-end">
                    <div class="col-md-6">
                        <div class="mt-3" style="width: 250px;">
                            <input v-model="searchCategory" class="form-control" name="search"
                                placeholder="Search by Category" @keyup="search" />
                        </div>
                    </div>
                    <div class="col-md-6 d-flex justify-content-end">
                        <div class="mt-3 d-flex align-items-center" style="width: 350px;">
                            <label for="select-category" class="form-control-label mr-2">Category</label>
                            <select id="select-category" class="form-control" v-model="category"
                                @change="changeCategory">
                                <option value="Select Category" id="0">Select Category</option>
                                <option v-for="(f, index) in categoryList" :value="f.value" :data="f"
                                    :key="index + f.value">{{
                                        f.value
                                    }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div v-if="categoryImageDataList.length === 0" class="mt-4 d-flex justify-content-center">Data Not
                    Found.</div>
                <div class="gallery-grid thumbnail-scroll">
                    <div class="thumb-card" v-for="(image, index) in categoryImageDataList" :key="index"
                        @click="openModal(image)">

                        <img :src="image.image_url" :alt="image.title" class="thumbnail" />
                        <div class="thumb-card-body">
                            <p class="title">{{ image.name || 'Name' }}</p>
                            <p class="source">{{ image.category_name || 'Category' }}</p>
                            <!-- Action buttons -->
                            <div class="card-actions">
                                <button class="btn edit" @click.stop="editImage(index)">Edit</button>
                                <button class="btn mail" @click.stop="sendMail(index)"><img
                                        src="../../images/communication.png" alt="Send Notification"
                                        style="width: 24px; height: 24px;" /></button>
                                <button class="btn delete" @click.stop="deleteImage(index)">Delete</button>
                            </div>
                        </div>
                    </div>

                    <!-- Modal -->
                    <div class="modal-overlay" v-if="selectedImage" @click.self="selectedImage = null">
                        <div class="modal-content">
                            <span class="close-btn" @click="selectedImage = null">&times;</span>
                            <img :src="selectedImage.image_url" class="modal-img" />
                            <p class="modal-title">{{ selectedImage.name }}</p>
                            <p class="modal-source">{{ selectedImage.category_name }}</p>
                        </div>
                    </div>
                </div>
            </v-tab>
            <v-tab title="Send Notification">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12 mb-2">
                            <div class="d-flex justify-content-end mb-2">
                                <div>
                                    <label for="emailChk" class="form-check-label ">
                                        <input id="emailChk" type="checkbox" name="inline-checkbox2"
                                            v-model="notification.email" class="form-check-input">Email
                                    </label>
                                </div>
                                <div class="mr-5 ml-5">
                                    <label for="whatsappChk" class="form-check-label ">
                                        <input id="whatsappChk" type="checkbox" name="inline-checkbox2"
                                            v-model="notification.whatsapp" class="form-check-input">Whatsapp
                                    </label>
                                </div>
                                <div>
                                    <label for="smsChk" class="form-check-label ">
                                        <input id="smsChk" type="checkbox" name="inline-checkbox2"
                                            v-model="notification.sms" class="form-check-input">SMS
                                    </label>
                                </div>
                            </div>
                            <table class="custom-table fonts11" style="table-layout: fixed;">
                                <tr>
                                    <div class="table-responsive app" v-dragscroll="true">
                                        <table id="s1s-sector" class="table table-bordered app-inner mb-0"
                                            style="font-size: 11px;">
                                            <thead style="width: 99.5%;" v-if="tableFields.length > 0">
                                                <tr>
                                                    <th class="text-center p-1" style="width: 50px;"><input
                                                            type="checkbox" @change="selectAllContentChkChange"
                                                            v-model="selectAllContent"></th>
                                                    <th class="align-middle p-1" v-for="(lblObj, lIdx) in tableFields">
                                                        {{ lblObj.title }}</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="tableFields.length > 0">
                                                <tr v-for="(row, index, key) in contactList"
                                                    v-bind:key="'row' + row + index">
                                                    <td class="text-center p-1" style="width: 50px;"><input
                                                            type="checkbox" v-model="row.selected"
                                                            @change="contentRowChkChange(row.selected, index)"></td>
                                                    <td class="p-1" v-for="(fieldObj, ind) in tableFields"
                                                        v-bind:key="ind + '-td-' + index + key">
                                                        <span>
                                                            {{ row[fieldObj.field] }}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot v-if="contactList.length === 0">
                                                <tr>
                                                    <td :colspan="tableFields.length">
                                                        <div class="alert alert-danger" role="alert">No data found!
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </tr>
                            </table>
                            <div class="d-flex align-items-center mt-2" :style="{ backgroundColor: '#dcdcdc' }">
                                <div class="d-flex align-items-center col-md-2">
                                    <label for="by_name" class="mb-0" style="font-weight: bold;">
                                        <input id="by_name" type="checkbox" name="inline-checkbox2" v-model="by_name"
                                            class="mr-2">By Name
                                    </label>
                                </div>
                                |
                                <div class="d-flex align-items-center mt-2 mb-2 pl-4 col-md-10">
                                    <label class="mb-0 mr-2" style="font-weight: bold;">Subject:</label>
                                    <input type="text" class="form-control inmarginbtm" style="font-size: small;"
                                        placeholder="Subject" v-model="subject" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <vue-ckeditor id="email-ck" v-model="mailContent" :config="config"
                                @fileUploadRequest="onFileUploadRequest($event)"
                                @fileUploadResponse="onFileUploadResponse($event)" />
                        </div>
                        <div style="display: flex;justify-content: flex-end;margin-top: 8px;">
                            <button type="button" @click="sendEmailHandler" class="btn-sm mb5 btn-primary"
                                style="padding: 0.2rem;">Send</button>
                        </div>

                    </div>
                </div>
            </v-tab>
        </vue-tabs>

    </div>
</template>
<script>
import http from "@/lib/http";
import VueCkeditor from "vue-ckeditor2";
import UploadForm from "./UpdateForm.vue"
export default {
    components: { UploadForm, VueCkeditor, },
    //mixins: [commonMixins],
    name: "Marketing",
    created() {
        this.getCategoryURL = "/frontend/category/marketing/get";
        this.getUrl = "/frontend/marketing/get";
        this.createUpdateUrl = "/frontend/marketing/create_update/update";
        this.deleteUrl = "/frontend/marketing/delete";
        this.getCategoryCall();
        this.getCategoryListData();
    },
    data() {
        return {
            tabOneTitle: "create",
            categoryList: [],
            category: "Select Category",
            searchCategory: "",
            curTab: "",
            selectedCategoryObj: [],
            getCategoryURL: "/frontend/category/marketing/get",
            getUrl: "/frontend/marketing/get",
            createUpdateUrl: "/frontend/marketing/create_update/update",
            deleteUrl: "/frontend/marketing/delete",
            selectedImage: null,
            selectedMailImageObj: null,
            categoryImageDataList: [
                /* {
                    "_id": "686fb6d603c7919a60da358d",
                    "name": "Test 1",
                    "datetime": "2025-07-10 12:49:26",
                    "date_str": "2025-07-10",
                    "category_id": "686f95c40529ed9892ca626a",
                    "category_name": null,
                    "image_url": "https://nobiasinvesting.s3.ap-south-1.amazonaws.com/marketing/56a5dfdb9cbb434ba9d63038df04307f.jpg"
                }, */
            ],
            config: {
                toolbar: [
                    {
                        name: "snddocument",
                        items: [
                            "Source",
                            "-",
                            "Save",
                            "NewPage",
                            "DocProps",
                            "Preview",
                            "Print",
                            "-",
                            "Templates"
                        ]
                    },
                    { name: "clipboard", items: ["Undo", "Redo"] },
                    {
                        name: "editing",
                        items: [
                            "Find",
                            "Replace",
                            "-",
                            "SelectAll",
                            "-",
                            "SpellChecker",
                            "Scayt"
                        ]
                    },
                    {
                        name: "forms",
                        items: [
                            "Form",
                            "Checkbox",
                            "Radio",
                            "TextField",
                            "Textarea",
                            "Select",
                            "Button",
                            "ImageButton",
                            "HiddenField"
                        ]
                    },
                    "/",
                    {
                        name: "basicstyles",
                        items: [
                            "Bold",
                            "Italic",
                            "Underline",
                            "Strike",
                            "Subscript",
                            "Superscript",
                            "-",
                            "RemoveFormat"
                        ]
                    },
                    {
                        name: "paragraph",
                        items: [
                            "NumberedList",
                            "BulletedList",
                            "-",
                            "Outdent",
                            "Indent",
                            "-",
                            "Blockquote",
                            "CreateDiv",
                            "-",
                            "JustifyLeft",
                            "JustifyCenter",
                            "JustifyRight",
                            "JustifyBlock",
                            "-",
                            "BidiLtr",
                            "BidiRtl"
                        ]
                    },
                    { name: "links", items: ["Link", "Unlink", "Anchor"] },
                    {
                        name: "insert",
                        items: [
                            "Image",
                            // "Flash",
                            "Table",
                            "HorizontalRule",
                            "Smiley",
                            "SpecialChar",
                            "PageBreak",
                            "Iframe"
                        ]
                    },
                    { name: "styles", items: ["Styles", "Format", "FontSize"] },
                    { name: "colors", items: ["TextColor", "BGColor"] },
                    { name: "tools", items: ["Maximize", "ShowBlocks"] }
                ]
            },
            tableFields: [
                { title: "Name", field: "name" },
                { title: "Email", field: "email" },
                { title: "Whatsapp", field: "whatsapp" },
                { title: "Phone", field: "phone" },
            ],
            mailContent: "",
            getContentList: [],
            contactList: [],
            selContents: [],
            selectAllContent: "",
            notification: { email: true, whatsapp: false, sms: false },
            by_name: false,
            subject: "",
        };
    },
    methods: {
        onFileUploadRequest(evt) {
            console.log(evt);
        },
        onFileUploadResponse(evt) {
            console.log(evt);
        },
        sendEmailHandler() {
            const self = this;
            console.log('#<<< sendEmailHandler >>># ', this.mailContent);
            const selectedContacts = this.contactList
                .filter(item => item.selected)
                .map(item => item._id);

            if (selectedContacts.length === 0) {
                self.$toastr.error("Please select at least one contact before sending the email.", "", {});
                return;
            }

            const notificationObj = Object.keys(this.notification).filter(
                (key) => this.notification[key] === true
            );

            if (notificationObj.length === 0) {
                self.$toastr.error("Please choose at least one way to contact you: Email, WhatsApp, or SMS.", "", {});
                return;
            }

            if (this.subject.trim() === "") {
                this.$toastr.error("Subject is required.", "", {});
                return;
            }

            const payload = {
                "partner_name": "marketing",
                "partner_id": this.selectedMailImageObj._id,
                "notification_type": notificationObj,
                "users": selectedContacts,
                "content_data": this.mailContent,
                "by_name": this.by_name ? "True" : "False",
                "subject": this.subject,
            }
            console.log('#<<< selectedContacts payload: >>># ', payload);
            http.post("/frontend/notification", payload, function (error, response) {
                console.log('### notification response ###::: ', response);
                if (response.responseType === 'success') {
                    self.$toastr.success(response.msg, "", {});
                    self.curTab = "view";
                } else {
                    self.$toastr.error(response.msg, "", {});
                }
            });

        },
        selectAllContentChkChange() {
            let contactFilterData = this.contactList.map((item) => {
                return { selected: this.selectAllContent, "_id": item._id, "user_id": item.user_id, "email": item.email, "name": item.name, "phone": item.phone, "whatsapp": item.whatsapp };
            });
            //console.log('>>> this.selectAllContent', this.selectAllContent);
            this.contactList = contactFilterData;
        },
        contentRowChkChange(select, index) {
            console.log('>>> contentRowChkChange', select, index);
            this.contactList[index].selected = select;
            this.checkAllChkSelectedOrNot();
        },
        checkAllChkSelectedOrNot() {
            let allSelected = this.contactList.filter((item) => {
                return item.selected;
            });
            if (this.contactList.length === allSelected.length) {
                this.selectAllContent = true;
            } else {
                this.selectAllContent = false;
            }
            //console.log('<<< allSelected >>>', this.contactList.length, allSelected.length);
        },
        mailContentSet() {
            this.mailContent = `<p>Product Marketing</p><p><img alt="" src="${this.selectedMailImageObj.image_url}" style="height:300px;" /></p>`;
        },
        fetchContentList() {
            let self = this;
            http.get("/frontend/contacts/get", {}, (error, response) => {
                console.log('fetchContentList:::', response);
                if (response.status === 'success') {
                    //self.contactList = response.data;
                    let contactFilterData = response.data.map((item) => {
                        return { selected: false, "_id": item._id, "user_id": item.user_id, "email": item.email, "name": item.name, "phone": item.phone, "whatsapp": item.whatsapp };
                    });
                    //console.log('>>> contactFilterData::: ', contactFilterData);
                    self.contactList = contactFilterData;
                }
            });
        },
        changeCategory(event) {
            let self = this;
            console.log('changeCategory - e.target::: ', event.target.selectedIndex, self.categoryList[event.target.selectedIndex - 1]);
            console.log('self.category:::', self.category)
            self.searchCategory = "";
            let param = { "category_id": self.category === "Select Category" ? "" : self.categoryList[event.target.selectedIndex - 1].id }
            http.post("/frontend/marketing/categorywise/search", param, function (
                error,
                response
            ) {
                console.log('response::: ', response, "error::: ", error);
                if (!error) {
                    //console.log("response >>>", response);
                    self.categoryImageDataList = response;
                } else {
                    console.log("error", error);
                }
            });
            //}
        },
        search() {
            console.log(this.searchCategory);
            if (this.searchCategory.length > 1) {
                this.category = "Select Category";
                this.fetchCategory(this.searchCategory);
            }
            if (this.searchCategory.length === 0) {
                console.log("Reset");
                this.category = "Select Category";
                this.reset();
            } else {
                console.log("Not Reset");
            }
        },
        getCategoryListData() {
            let self = this;
            console.log('self.cGetUrl >>>>', self.getCategoryURL);
            if (self.getCategoryURL.length > 0) {
                http.get(self.getCategoryURL, {}, (error, response) => {
                    console.log('getCategoryMasterData:', response);
                    if (response.status === 'success') {
                        const categoryData = response.data;
                        let categoryFilterData = categoryData.map((item) => {
                            return { id: item._id, value: item.category_name };
                        });
                        //console.log('>>> categoryList >>> ', categoryFilterData);
                        self.categoryList = categoryFilterData;
                    }
                });
            }
        },
        fetchCategory(search) {
            let self = this;
            const apiURL = `/frontend/marketing/search?search=${search}`
            http.get(apiURL, {}, (error, response) => {
                console.log('Search Category Call >>>', response);
                self.categoryImageDataList = response;
            });
        },
        reset() {
            this.searchCategory = "";
            this.fetchCategory(this.searchCategory);
        },
        getCategoryCall() {
            let self = this;
            http.get(self.getUrl, {}, (error, response) => {
                console.log('getCategoryCall >>>', response);
                if (response.status === 'success') {
                    const categoryData = response.data;
                    /* "_id": "686fb6d603c7919a60da358d",
                    "name": "Test 1",
                    "datetime": "2025-07-10 12:49:26",
                    "date_str": "2025-07-10",
                    "category_id": "686f95c40529ed9892ca626a",
                    "category_name": null,
                    "image_url": "https://nobiasinvesting.s3.ap-south-1.amazonaws.com/marketing/56a5dfdb9cbb434ba9d63038df04307f.jpg" */

                    /* let categoryFilterData = categoryData.map((item) => {
                        return { _id: item._id, name: item.name, category_id: item.category_id, category_name: item.category_name, image_url: "https://via.placeholder.com/300x200?text=Mount+Fuji" };
                    });
                    self.categoryImageDataList = categoryFilterData; */
                    self.categoryImageDataList = response.data;
                }
            });
        },
        openModal(image) {
            this.selectedImage = image;
            this.selectedMailImageObj = null;
        },
        editImage(index) {
            this.selectedCategoryObj = [];
            this.selectedCategoryObj = this.categoryImageDataList[index];
            console.log('### selectedCategoryObj', this.selectedCategoryObj);
            this.tabOneTitle = "edit";
            this.curTab = "edit";
            // Example: Prompt to change title
            /* const newTitle = prompt("Edit Title:", selectedCategoryImage.title);
            if (newTitle !== null) {
                this.categoryImageDataList[index].title = newTitle;
            } */
        },
        sendMail(index) {
            //console.log('image_url:: ', this.categoryImageDataList[index])
            this.selectedMailImageObj = this.categoryImageDataList[index];
            this.mailContentSet();
            this.curTab = "Send Notification";
        },
        deleteImage(index) {
            let self = this;
            if (confirm("Are you sure you want to delete this image?")) {
                const selectedThumb = this.categoryImageDataList[index];
                console.log('selectedThumb >>>', selectedThumb);

                let param = { "_id": selectedThumb._id };

                http.post("/frontend/marketing/delete", param, function (
                    error,
                    response
                ) {

                    console.log("delete response >>>", response);
                    if (response.responseType === 'success') {
                        self.$toastr.success(response.msg, "", {});
                        self.getCategoryCall();
                    } else {
                        self.$toastr.error(response.msg, "", {});
                    }
                });
            }
        },
        getTabData(tabIndex, newTab, oldTab) {
            console.log('# tabs:', tabIndex, newTab.title, oldTab.title);

            if (tabIndex !== 0) {
                this.selectedCategoryObj = [];
                this.tabOneTitle = "create";
            } else {
                console.log('### selectedCategoryObj', this.selectedCategoryObj, this.category)
                //this.category = "Select Category";
                this.category = this.selectedCategoryObj.category_name;
            }
            if (newTab.title === 'Send Notification') {
                console.log('### mailContent          >>>', this.mailContent.length);
                console.log('### selectedMailImageObj >>>', this.selectedMailImageObj);
                if (this.selectedMailImageObj == null || this.mailContent.length === 0) {
                    alert("Kindly select an image from the 'VIEW' tab before proceeding.")
                    this.curTab = oldTab.title === "view" ? this.tabOneTitle : "view";
                    //this.curTab = oldTab.title;
                    return;
                }
                this.fetchContentList();
            } else {
                this.mailContent = "";
                this.selectedMailImageObj = null;
            }
            this.curTab = newTab.title;
        },
    }
}
</script>
<style scoped>
.tab-border {
    border: 1px solid #c3c3c3;
}

.cat-compo {
    padding: 0 10rem;
}

/* -------- */
.gallery-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 16px;
    padding: 20px;
}

.thumbnail-scroll {
    max-height: 70vh;
    overflow-y: auto;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 16px;
    padding-right: 10px;
}

.thumb-card {
    background: #ffffff;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.2s;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    color: white;
}

.thumb-card:hover {
    transform: scale(1.03);
}

.thumbnail {
    width: 100%;
    height: 140px;
    object-fit: cover;
}

.thumb-card-body {
    padding: 10px;
}

.title {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 4px;
}

.source {
    font-size: 12px;
    color: #aaa;
}

/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    max-width: 90vw;
    max-height: 90vh;
    text-align: center;
    position: relative;
    width: fit-content;
}

.modal-img {
    max-width: 100%;
    max-height: 70vh;
    object-fit: contain;
}

.modal-title {
    font-weight: bold;
    margin-top: 10px;
}

.modal-source {
    color: gray;
    font-size: 14px;
}

.close-btn {
    position: absolute;
    top: 8px;
    right: 12px;
    font-size: 24px;
    cursor: pointer;
}

/* Nav Button */
.card-actions {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
}

.btn {
    padding: 4px 10px;
    font-size: 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    color: white;
}

.btn.edit {
    background-color: #007bff;
}

.btn.mail {
    background-color: #ffffff;
    border: 1px solid #00bd3a;
}

.btn.delete {
    background-color: #dc3545;
}

.custom-table {
    width: 100%;
    border-collapse: collapse;
}

.custom-table thead,
.custom-table tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
}

.custom-table tbody {
    display: block;
    height: 165px;
    overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/views/partners/Marketing.vue